/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

export interface User {
  id: string;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  age: number;
  login: string;
  picture: string;
  address: Address;
  settings: Settings;
  image: Image;
  active: Boolean;
}

export interface Address {
  id: number;
  country: string;
  state: string;
  city: string;
  street: string;
  outdoorNumber: string;
  interiorNumber: string;
  neighborhood: string;
  zipCode: string;
}

export interface Image {
  id: number;
  path: string;
  name: string;
  aproved: boolean;
}

export interface Settings {
  id: string;
  themeName: string;
}

export abstract class UserData {
  abstract get gridDataSource(): DataSource;
  abstract getCurrentUser(): Observable<User>;
  abstract list(pageNumber: number, pageSize: number): Observable<User[]>;
  abstract get(id: string);
  abstract update(user: User);
  abstract updateCurrent(user: User);
  abstract create(user: User);
  abstract delete(id: string);
}
